// extracted by mini-css-extract-plugin
export default {"optionWrapper":"styles_optionWrapper__ZaObb","iconWrapper":"styles_iconWrapper__qRuwo"};